import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'

import styles from './FieldHelpIcon.module.scss'

const propTypes = {
  /** `FormattedMessage` id for tooltip body */
  tooltipId: PropTypes.string.isRequired,
}

/**
 * Small info icon that shows a translated tooltip on hover/focus (keyboard accessible via focus on wrapper).
 */
function FieldHelpIcon(props) {
  const { tooltipId } = props
  const intl = useIntl()
  const ariaLabel = intl.formatMessage({ id: tooltipId })

  return (
    <OverlayTrigger
      placement="auto"
      overlay={
        <Tooltip
          id={`tooltip-${tooltipId.replace(/\./g, '-')}`}
          className={clsx('modal-tooltip text-left', styles.tooltip)}
        >
          <FormattedMessage id={tooltipId} />
        </Tooltip>
      }
    >
      <span
        className={clsx('ml-1 text-color-secondary', styles.trigger)}
        tabIndex={0}
        role="button"
        aria-label={ariaLabel}
      >
        <i className="fas fa-circle-info font-size-small" aria-hidden="true" />
      </span>
    </OverlayTrigger>
  )
}

FieldHelpIcon.propTypes = propTypes

export default FieldHelpIcon
